import { render, staticRenderFns } from "./Page-1.vue?vue&type=template&id=44486f46&scoped=true&"
var script = {}
import style0 from "./Page-1.vue?vue&type=style&index=0&id=44486f46&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44486f46",
  null
  
)

export default component.exports